import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'slick';

export class infoGraphic{
	private $scope = $('.infograph-grid');

	infoIsotope(): any{
		let _self = this;
		var elem = _self.$scope.find('.grid');
		var iso = new Isotope( elem[0], {
			// options
			itemSelector: '.element-items',
			layoutMode: 'fitRows',
			filter: '.airlines'
		});

		$('.sort-button-group').on( 'click', 'a', function() {
			var filterValue = (event.target as HTMLElement).getAttribute('data-filter');
			iso.arrange({ filter: filterValue });
		});
	}

	infoIsotopeMob(): any{
		$('.redeemSteps').slick({
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: false,
			nextArrow: false,
			dots: true
		});

		let $redeemSel: any = $('.redeemSel').selectize();
		let $redeemSelected: any = $redeemSel[0].selectize;
		let $redeemSteps: any = $('.redeem-steps');
		let $redeemGetValue: any = $redeemSelected.getValue();

		$redeemSteps.hide();
		$('#' + $redeemGetValue).show();

		$redeemSelected.on('change', function(){
			let $redeemGetValue: any = $redeemSelected.getValue();
			$redeemSteps.hide();
			$('#' + $redeemGetValue).show();
			$('.redeemSteps').slick('setPosition');
		});
	}
}


let scope:Element = document.querySelector('.infographic');
if (scope){
	try {
	let infographic = new infoGraphic();
			infographic.infoIsotope();
			infographic.infoIsotopeMob();
	} catch(e) {console.error(e);}
}
